<template>
  <div class="sticky">
    <button class="exit" @click="$emit('update', false)">
      <svg width="10.606689" height="10.606445" viewBox="0 0 10.6067 10.6064" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.3 4.12L9.42 0L10.6 1.17L6.48 5.3L10.6 9.42L9.42 10.6L5.3 6.48L1.17 10.6L0 9.42L4.12 5.3L0 1.17L1.17 0L5.3 4.12Z" fill="#050505"/>
      </svg>
    </button>
    <div v-for="(section, key) in sections" :key="key" class="filter-section">
      <div class="filter-header" @click="filters[key].open = !filters[key].open">
        <span>{{ section.label }}</span>
        <svg width="12.728027" height="7.778076" viewBox="0 0 12.728 7.77808" fill="none" xmlns="http://www.w3.org/2000/svg" :class="{ 'rotated': !filters[key].open }">
          <path d="M6.36 2.82L1.41 7.77L0 6.36L6.36 0L12.72 6.36L11.31 7.77L6.36 2.82Z" fill="#1D1D34" />
        </svg>
      </div>
      <div class="filter-body" :style="{ opacity: filters[key].open ? 1 : 0, maxHeight: filters[key].open ? '340px' : '0px' }">
        <CategorySelect :name="key" :categories="section.items" v-model="filters[key].value" />
      </div>
    </div>
  </div>
</template>

<script>
import CategorySelect from '../UI/Category/CategorySelect.vue';
export default {
  components: {
    CategorySelect,
  },
  props: {
    filters: Object,
    categories: { type: Array, default: () => [] },
    makes: { type: Array, default: () => [] },
  },
  emits: ['update'],
  computed: {
    sections() {
      const withCount = list => list.map(item => ({ id: item.id, name: `${item.name} (${item.count})` }));
      return {
        category: { label: 'Categories', items: withCount(this.categories) },
        make: { label: 'Manufacturer', items: withCount(this.makes) },
      };
    },
  },
};
</script>

<style scoped>
.exit{
  display: none;
  width: 32px;
  height: 32px;
  background: rgb(222, 230, 234);
  border-radius: 100%;
  cursor: pointer;
}
.sticky{
  position: sticky;
  top: 90px;
}
.filter-section + .filter-section{
  margin-top: 8px;
}
.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  color: rgb(5, 5, 5);
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  margin-bottom: 24px;
}
.rotated {
  transform: rotate(180deg);
  transition: transform 0.3s ease-in-out;
}
.filter-body {
  overflow-y: auto;
  transition: opacity 0.3s ease, max-height 0.3s ease;
}
.filter-body::-webkit-scrollbar {
  width: 2px;
}
.filter-body::-webkit-scrollbar-thumb {
  background: rgb(222, 230, 234);
  border-radius: 32px;
}
@media (max-width: 1024px) {
  .sticky{
    display: none;
    position: fixed;
  }
  .sticky.show{
    display: block;
    position: fixed;
    width: 100%;
    background-color: white;
    z-index: 999;
    height: 100vh;
    top: 0;
    left: 0;
    padding: 24px;
    padding-top: 54px;
    overflow-y: auto;
    padding-bottom: 100px;
  }
  .exit{
    display: block;
    position: absolute;
    right: 16px;
    top: 16px;
  }
}
</style>
